import React, { useState, useEffect } from "react";
import { BsGithub } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { FiExternalLink, FiLink } from "react-icons/fi";
import { SiGmail } from "react-icons/si";
import { Link } from "react-router-dom";

import background from "../../assets/images/gmail-background.svg";

function Contact() {
  const [clipboard, setClipboard] = useState("");

  useEffect(() => {
    if (clipboard !== "") {
      setTimeout(() => {
        setClipboard("");
      }, 2500);
    }
  }, [clipboard]);
  const copyLink = (text) => {
    navigator.clipboard.writeText(text);
    setClipboard("Copied to clipboard");
  };
  return (
    <div className="mt-[26%] h-[100vh] ">
      <div className="relative flex flex-col justify-center items-center z-10">
        <div className="absolute z-0 mt-[20%] ml-[30%]">
          <img src={background} />
        </div>
        <div className="flex flex-col items-center mt-48 relative z-10 w-[100%]">
          <h1 className="text-cool-400 font-bold text-6xl font-monts ">
            Contact Me
          </h1>

          <p className="font-monts text-cool-400 text-lg xmd:text-2xl md:text-xl pt-12 w-[90%] text-center">
            Want to get in touch? The best way to reach me is through my email
          </p>
          <div className="relative flex flex-col items-center">
            <a
              href="mailto:eddiemwiti10@gmail.com"
              onClick={() => copyLink("eddiemwiti10@gmail.com")}
              className="font-monts font-black text-xl md:text-4xl mt-32 text-white bg-cool-400 p-6 px-12 rounded-full cursor-pointer hover:shadow-md w-70%"
            >
              eddiemwiti10@gmail.com
            </a>
            <span
              className={
                clipboard === ""
                  ? "hidden"
                  : "bg-cool-100 px-4 py-1 rounded-xl  absolute mt-[63%] md:mt-[43%]"
              }
            >
              Copied to clipboard
            </span>
          </div>
        </div>

        <div className="divide-y divide-gray-400 w-full flex flex-col items-center">
          <div className=""></div>
          <div className="flex pt-20 mt-40 gap-x-20 gap-y-5 flex-wrap w-[80%] justify-center relative z-10">
            <div className=" ">
              <a
                href="https://www.linkedin.com/in/eddiegikundi/"
                target="_blank"
                className=" text-cool-400 hover:text-cool-300 transition hover:cursor-pointer flex gap-3"
              >
                <FaLinkedin size={40} />
                <p className="flex items-center">
                  <span>My LinkedIn</span> <FiExternalLink className="ml-2" />{" "}
                </p>
              </a>
            </div>

            <div className="">
              <a
                href="https://github.com/eddiemg10"
                target="_blank"
                className=" text-cool-400 hover:text-cool-300 transition hover:cursor-pointer flex gap-3"
              >
                <BsGithub size={30} />
                <p className="flex items-center">
                  <span>My Github</span> <FiExternalLink className="ml-2" />{" "}
                </p>
              </a>
            </div>
            <div className="">
              <Link
                to="contact"
                className=" text-cool-400 hover:text-cool-300 transition hover:cursor-pointer flex gap-3"
              >
                <SiGmail size={30} />
                <p className="flex items-center">
                  <span>Send me an email</span>
                </p>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
